import { css } from "@stubhub/broadway-foundation/css";

export const connectedContainer = css({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "center",
  columnGap: "primitives.100",
  paddingBlock: "primitives.150",
  paddingInline: "primitives.150",
  backgroundColor: "[black]",
  borderStartStartRadius: "element.default",
  borderStartEndRadius: "element.default",
  borderEndStartRadius: "element.default",
  borderEndEndRadius: "element.default",
});

export const connectedText = css({
  color: "text.onFill",
  fontSize: "[14px]",
  fontWeight: "bold",
  lineHeight: "[20px]",
});

export const connectedIndicator = css({
  display: "inline-block",
  width: "primitives.100",
  height: "primitives.100",
  borderStartStartRadius: "full",
  borderStartEndRadius: "full",
  borderEndStartRadius: "full",
  borderEndEndRadius: "full",
  backgroundColor: "[#1db954]",
  flexShrink: "0",
});

export const manageWrapper = css({
  position: "relative",
  display: "inline-block",
  marginInlineStart: "auto",
});

export const manageButton = css({
  cursor: "pointer",
  color: "text.onFill",
  fontSize: "[12px]",
  fontWeight: "[400]",
  lineHeight: "[16px]",
  whiteSpace: "nowrap",
  backgroundColor: "[transparent]",
  borderBlockStartWidth: "primitives.0",
  borderBlockEndWidth: "primitives.0",
  borderInlineStartWidth: "primitives.0",
  borderInlineEndWidth: "primitives.0",
  paddingBlock: "primitives.0",
  paddingInline: "primitives.0",
  _hover: {
    color: "text.onFill",
  },
});

export const tooltipContainer = css({
  width: "[250px]",
  backgroundColor: "bg.surface",
  borderStartStartRadius: "element.default",
  borderStartEndRadius: "element.default",
  borderEndStartRadius: "element.default",
  borderEndEndRadius: "element.default",
  paddingBlock: "primitives.150",
  paddingInline: "primitives.200",
  position: "absolute",
  zIndex: "[1]",
  insetBlockStart: "[50%]",
  insetInlineEnd: "[calc(100% + 8px)]",
  transform: "[translateY(-50%)]",
  boxShadow: "[rgba(0,0,0,0.3) 0 4px 10px]",
});

export const tooltipText = css({
  paddingBlockEnd: "primitives.100",
});

export const helpCenterLink = css({
  color: "text.brand",
  marginBlockStart: "primitives.50",
});
